import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { FieldArray } from 'redux-form';

import FiltersFieldArray from 'components/fields/FiltersFieldArray';

const FiltersFields = ({ prefix, Filters, colored, id }) => {
  const filtersKeys = Filters ? Object.keys(Filters) : null;
  return (
    <Fragment>
      {prefix}
      {filtersKeys && filtersKeys.map((filtersKey, index) => (
        <FieldArray
          id={id}
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          name={Filters[filtersKey].input.name}
          prefix={filtersKey}
          colored={colored.indexOf(Filters[filtersKey].input.name) !== -1}
          component={FiltersFieldArray}
        />
      ))}
    </Fragment>
  );
};

FiltersFields.propTypes = {
  prefix: PropTypes.node,
  id: PropTypes.string.isRequired,
  Filters: PropTypes.shape({
    input: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
  }),
  colored: PropTypes.arrayOf(PropTypes.string),
};

FiltersFields.defaultProps = {
  prefix: null,
  Filters: null,
  colored: [],
};

export default FiltersFields;



// WEBPACK FOOTER //
// ./src/components/fields/FiltersFields.js